<form [formGroup] = "form">
  <h1 style="display:flex;" *ngIf ="mode ==1" mat-dialog-title> Editing {{data.job_type}}<p *ngIf="inactive" style="color: rgb(255, 50, 50); font-size:20px; margin-left: 10px;"> Inactive!</p></h1>
  <h1 *ngIf ="mode ==2" mat-dialog-title> Add Job type </h1>

  <div mat-dialog-content>
    <mat-form-field style="width:90%">
        <mat-label>Name:</mat-label>
        <input matInput formControlName = "job_type" (keyup)="checkForDuplication()">
      </mat-form-field>

    <br> 
    <div *ngIf = 'textToDisplay.length > 0 && display === true'>
      <span *ngIf="isDuplicate"><p style="color:red;">{{textToDisplay}}</p></span>
      <span *ngIf="!isDuplicate"><p style="color:lightgreen;">{{textToDisplay}}</p></span>
     </div>

        <div style="padding-bottom: 2em;">
        <mat-label>Site Visit Required?:  </mat-label>
        <mat-checkbox formControlName = "sitevisitrqd"></mat-checkbox>
        </div>
  
      <div>
      <mat-form-field style="width:90%">
        <mat-label >Category</mat-label>
        <mat-select formControlName = "category">
          <mat-option value="Energy">Energy</mat-option>
          <mat-option value="QI">QI</mat-option>
        </mat-select>
      </mat-form-field>
        </div>

        <div>
        <mat-label>Inactive?:  </mat-label>
        <mat-checkbox (change)="onToggleInactive()" formControlName = "inactivejobtype"></mat-checkbox>
        </div>  

        <div style="display:flex; flex-direction:column; margin-left: 10px;" *ngIf="data.canSeeCerts">
        <div style="padding-top: 2em;">
        <mat-label>Certs required: </mat-label>
       </div> 

          <div style="display: flex; flex-direction: column;">        
              <mat-checkbox *ngFor="let cert of certifications;" 
              [checked]="isChecked(cert)"
              (change)="onCertSelected($event, cert)">
              {{cert}}
            </mat-checkbox>
          </div>
        </div>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
    <button *ngIf ="mode ==1" mat-button  (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    <button *ngIf ="mode ==2" mat-button  (click)="add()"  [mat-dialog-close]="data" cdkFocusInitial>Add</button>
  </div>
  </form>
